import {inject, observer} from "mobx-react";
import {Button, Dropdown, Icon, Tag, Pagination, message, Spin, Modal, Form, DatePicker} from 'antd';
import LogDialog from '../dialog/CoworkLogDialog'
import {createMarkMenu} from '../../../util/CoworkUtil';
import {WeaDropdown, WeaLocaleProvider,WeaTag} from 'ecCom';
const getLabel = WeaLocaleProvider.getLabel;

@inject('coworkStoreMap')
@observer
class Detail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      show: props.content && props.content.cowork.coworkBaseSettingMap.itemstate == '1',
      important: '',
      visiable: false,
    };
  }
  
  render() {
    const {content, labelList} = this.props;
    const {show, visiable} = this.state;
    const con = content.cowork || {}, {itemsVO = {}} = con;
    const coworkContentId = content.id;
    return (
      <div>
        <div className='cowork-content-container'>
          {/*<div className='cowork-content-detail'>
            <span className='cowork-content-detail-text'>{getLabel(382645, '协作详情')}</span>
            <div>
              {
                con.canEdit && con.canEdit == 1 ?
                  <Button className="cowork-content-detail-btn" onClick={() => this.edit()}>{getLabel(93, '编辑')}</Button> : null
              }
              {
                con.canEdit && con.canEdit == 1 && con.itemsVO.status == '2' ?
                  <Button className="cowork-content-detail-btn" onClick={this.operateCoworkItem.bind(this, coworkContentId, 'open')}>{getLabel(360, '打开')}</Button> : null
              }
              {
                con.canEdit && con.canEdit == 1 && con.itemsVO.status == '1' ?
                  <Button className="cowork-content-detail-btn" onClick={this.operateCoworkItem.bind(this, coworkContentId, 'end')}>{getLabel(405, '结束')}</Button> : null
              }
              <Button onClick={() => {this.showLogDialog(true)}} className="cowork-content-detail-btn">{getLabel(17480, '查看日志')}</Button>
              <a href={con && con.exportUrl} target="_blank">
                <Button className="cowork-content-detail-btn">{`${getLabel(17416,'导出')}${getLabel(15153,'相关交流')}`}</Button>
              </a>
            </div>
          </div>*/}
          <div className='cowork-content-discuss wea-f14'>
            <p>
              {con.itemsVO && con.itemsVO.name}
              {con.over == "1" && <Tag className="cowork-over">over</Tag>}
              <i
                onClick={this.starClick}
                className={con.isCoworkImportant == 0 ? "icon-coms-Collection" : "icon-coms-Collection2"}>
              </i>
              <em onClick={this.handleClick}
                  className={show ? 'icon-coms-up2' : 'icon-coms-down2'}>
              </em>
            </p>
            <span>
              {getLabel(2097, '负责人')}：
            <span>
              <a
                href={`javaScript:openhrm(${con.itemsVO && con.itemsVO.principalInfo && con.itemsVO.principalInfo.id});`}
                onClick={window.pointerXY}>{con.itemsVO && con.itemsVO.principalInfo && con.itemsVO.principalInfo.lastname}</a></span>
              {getLabel(83209,'版块')}：
            <span>{con.itemsVO && con.itemsVO.coworkBelongToTypeName}</span>
              {getLabel(1339, '创建时间')}：
            <span>{con.itemsVO && con.itemsVO.createdate} {con.itemsVO && con.itemsVO.createtime.substr(0, 8)}</span>
              {itemsVO.enddate && [
                getLabel(743,'结束时间')+"：",
                <span>{con.itemsVO && con.itemsVO.enddate} {con.itemsVO && con.itemsVO.endtime}</span>
              ]}
          </span>
            <div className='cowork-content-con'>
              
              <WeaDropdown overlay={createMarkMenu(labelList, this.mark)}>{getLabel(81293,'标记为')}...</WeaDropdown>
              {
                (con.labelBycoworkList && con.labelBycoworkList.length !== 0) && con.labelBycoworkList.map((label, index) => {
                  return <WeaTag className="cowork-content-tag" closable afterClose={this.deleteTag.bind(this, label)} key={label.id}
                              color={label.labelColor}>{label.labelName}</WeaTag>
                })}
            </div>
          </div>
          <div className={`cowork-content-text ${show ? '' : 'wea-cowork-display'}`}>
            {con.itemsVO && (
              <div className='cowork-content-text-main' dangerouslySetInnerHTML={{__html: con.itemsVO.remark}} key="remark"/>
            )}
          </div>
        </div>
        {/*<LogDialog visible={visiable} id={coworkContentId} showLogDialog={(bool) => this.showLogDialog(bool)}/>*/}
      </div>
    )
  }
  
  //处理图标上下显示
  componentWillReceiveProps(nextProps) {
    const {content} = this.props;
    let con = content.cowork;
    let show = con.coworkBaseSettingMap.itemstate == '1';
    if (nextProps.coworkId != this.props.coworkId) {
      this.setState({
        tabKey: 'list',
        show
      });
    }
  }
  
  //上下图标内容显示隐藏
  handleClick = () => {
    this.setState({
      show: !this.state.show,
      iconUpShow: !this.state.iconUpShow
    });
  }
  
  //标心效果
  starClick = () => {
    const {content, markItemAsType} = this.props;
    if (content && content.cowork) {
      let important = content.cowork.isCoworkImportant;
      if (important == '0') {
        markItemAsType({coworkids: content.id, type: 'important'});
      } else if (important == '1') {
        markItemAsType({coworkids: content.id, type: 'normal'});
      }
    }
  }
  
  //标星
  mark = (item) => {
    const {content, markItemAsType} = this.props;
    markItemAsType({coworkids: content.id, type: item.key});
  }
  
  //删除tag
  deleteTag = (label) => {
    const {content, deleteCoworkLabels} = this.props;
    let id = content.id;
    deleteCoworkLabels(label, id);
  }

  // //编辑
  // edit = () => {
  //   //storeMapKey通过Detail页面传进来
  //   const coworkNewStore = this.props.coworkStoreMap.getMapStore(this.props.storeMapKey);
  //   coworkNewStore.doEditInit();
  // }

  // //查看日志
  // showLogDialog = (bool) => {
  //   this.setState({
  //     visiable: bool
  //   })
  // }
  
  // operateCoworkItem = (id, type) => {
  //   let oper = this.props.operateCoworkItem;
  //   if (type == 'end') {
  //     Modal.confirm({
  //       content: getLabel(4910, '确认要结束该协作吗?','note'),
  //       onOk() {
  //         oper && oper(id, type);
  //       }
  //     });
  //   } else {
  //     oper && oper(id, type);
  //   }
  // }
}

export default Detail;


// WEBPACK FOOTER //
// ../src4js/pc4mobx/cowork/components/cowork/content/Detail.js